import { useEffect, useState } from 'react';
import { Modal, Row, Col, Form, FormInstance, Typography } from 'antd';
import UserForm from '../UserForm/UserForm';
import User from '../../../models/User';
import { isEmpty } from '../../../utils/functions';
import './UserModal.less';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { setInputSearchUser } from '../../../store/slice/userSlice';
/**
 * @component AddUserModal.tsx
 * @description AddUserModal component to add user.
 * @return { Component }
 */
interface AddUserModalProps {
  isModalVisible: boolean;
  user: User;
  setUser: (user: User, form: FormInstance) => void;
  isHidden: (show: boolean, user: User) => void;
  buttonText: string;
}
function AddUserModal(props: AddUserModalProps) {
  const [hidden, setHidden] = useState(props.isModalVisible);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const { Text } = Typography;
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        props.setUser(values, form);
        dispatch(setInputSearchUser(''));
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };
  const handleCancel = () => {
    setHidden(!props.isModalVisible);
    props.isHidden(false, {});
    if (isEmpty(props.user)) {
      form.resetFields();
    }
  };
  const userDelete = (isModal: boolean, user: User) => {
    setHidden(isModal);
    props.isHidden(isModal, user);
    dispatch(setInputSearchUser(''));
  };
  useEffect(() => {
    setHidden(props.isModalVisible);
  }, [props.isModalVisible]);
  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={
              isEmpty(props.user)
                ? 'Crear usuario'
                : [
                    'Editar Usuario: ',
                    <Text className="org-add-user__modal__tile" key={1}>
                      {props.user.nombre}
                    </Text>,
                  ]
            }
            visible={hidden}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={isEmpty(props.user) ? props.buttonText : 'Guardar Cambios'}
            cancelText="Cancelar"
            width={373}
            className={'org-add-user__modal'}
            maskClosable={false}
          >
            <UserForm user={props.user} form={form} userDelete={userDelete} />
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default AddUserModal;
